<template>
  <div class="choice mb-3 position-relative">

    <div class="component-row">
      <div class="component-col flex-grow-1">
        <!-- DISPLAY -->
        <div v-if="!editingData">
          <!-- CONTENT HAS BEEN SELECTED -->
          <span v-if="form.value !== null">
            <component
              v-for="(block, index) in template"
              :is="block.type"
              :key="index"
              :block="block"
              :blocks="blocks"
              :definitions="definitions"
              :asset="asset"
              :showActions="showActions"
            />
          </span>

          <!-- NO CONTENT HAS BEEN SELECTED -->
          <span v-else class="text-danger">
            Please make a selection
          </span>
        </div>

        <!-- EDITING -->
        <div v-else class="card card-body">
          <div v-for="(choice, choiceIndex) in blockData.template" :key="choiceIndex">
            <div class="row">
              <div class="col flex-grow-0">
                <button
                  @click.prevent="form.value = choiceIndex; changed = true"
                  class="btn btn-secondary text-nowrap"
                  :class="{ 'btn-success text-white': form.value === choiceIndex }"
                >
                  Option {{ choiceIndex + 1 }}
                </button>
              </div>
              <div class="col">
                <component
                  v-for="(block, index) in item(choice)"
                  :is="block.type"
                  :key="index"
                  :block="block"
                  :blocks="blocks"
                  :definitions="definitions"
                  :asset="asset"
                  :showActions="false"
                  forceHideActions
                />
              </div>
            </div>

            <hr v-if="choiceIndex + 1 !== blockData.template.length" />
          </div>
        </div>
      </div>

      <div class="component-col flex-grow-0">
        <div class="d-flex flex-nowrap">
          <Tag
            v-if="showActions && !editingData"
            @click.native="editingData = true"
            :block="blockData"
            :withCounterparty="state.withCounterparty"
          />
          <CommentsTrigger
            v-if="showActions && !editingData"
            v-on:toggle="comments = !comments"
            :showing="comments"
            :comments="commentsData"
          />
        </div>
      </div>
    </div>

    <Actions
      v-if="showActions && editingData"

      v-on:updated="updated"
      v-on:save="save"
      v-on:cancel="cancel"

      :saving="saving"
      :block="blockData"
      :edit-button-label="`${form.value !== null ? 'Make' : 'Change'} Choice`"

      :asset-id="asset.id"
      :model="asset.model"

      :changed="changed"
    />

    <Comments
      v-if="comments"
      :comments="commentsData"
      :contract="block.contract_id"
      :block="block.id"
      v-on:commentsUpdated="commentsUpdated"
      v-on:toggle="comments = !comments"
    />
  </div>
</template>

<script>
import contractComponents from '@/Mixins/contractComponents';
import helpers from '@/Mixins/helpers';
import contractHelpers from '@/Mixins/contractHelpers';
import Actions from '@/Pages/Asset/Contract/Actions/Actions';
import Comments from '@/Pages/Asset/Contract/Comments/Comments';
import CommentsTrigger from '@/Pages/Asset/Contract/Comments/CommentsTrigger';
import Tag from '@/Pages/Asset/Contract/Actions/Tag';

export default {
  mixins: [helpers, contractHelpers, contractComponents],

  components: {
    Actions,
    Comments,
    CommentsTrigger,
    Tag,
  },

  props: {
    dynamic: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    block: Object,
    blocks: Array,
    definitions: Array,
    showActions: Boolean,
    asset: Object,
    saveTrigger: String,
  },

  data() {
    return {
      blockData: this.block,
      commentsData: this.block.comments,

      editingData: this.editing,
      versions: false,
      comments: false,
      saving: false,
      changed: false,

      form: {
        value: this.block.value,
      },
    };
  },

  watch: {
    editing(value) {
      this.editingData = value;
    },
    saveTrigger() {
      this.save();
    },
  },

  computed: {
    template() {
      return this.block.template[0].default_reference
        ? this.blockData.template[this.form.value].content
        : this.blockData.template[this.form.value];
    },
  },

  methods: {
    updated(block) {
      this.blockData = block;
    },

    commentsUpdated(comments) {
      this.commentsData = comments;
    },

    item(choice) {
      return this.block.template[0].default_reference ? choice.content : choice;
    },

    cancel() {
      this.form.value = this.blockData.value;
      this.editingData = false;
      this.changed = false;
    },

    save() {
      this.saving = true;
      this.$nextTick(() => {
        window.axios
          .put(`/contract-block/${this.block.id}`, this.form)
          .then(({ data }) => {
            this.saving = false;
            this.editingData = this.userHasRole('approver');
            this.blockData = data;
            this.fetchAssetState(this.asset.id);
            this.changed = false;
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },
  },
};
</script>
